import React from "react";
import { ProductConsumer } from "../../../Context/AddProWakel";
import NumberFormat from "react-number-format";
const FooterOfParadan = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const { RPD_paraID, RPD_para$, RPD_paraRRR } = value;
          return (
            <>
              {/* second row */}
              <div className="row pt2">
                <div className="col-lg-10 col-12">
                  <div className="row ">
                    <div className="col-lg-3 col-4">
                      <h3 className="bg-white tc mt2">
                        <NumberFormat
                          displayType="text"
                          thousandSeparator={true}
                          value={RPD_para$}
                        />
                      </h3>
                    </div>
                    <div className="col-lg-2 col-4">
                      <h3 className="text-warning tc  mt1">پارە بە دۆلار</h3>
                    </div>
                    <div className="col-lg-2 col-4"></div>
                    <div className="col-lg-3 col-4">
                      <h3 className="bg-white tc mt2">
                        <NumberFormat
                          displayType="text"
                          thousandSeparator={true}
                          value={RPD_paraID}
                        />
                      </h3>
                    </div>
                    <div className="col-lg-2 col-4 mt1">
                      <h3 className="text-warning tc">پارە بە دینار</h3>
                    </div>
                  </div>
                </div>
              </div>
              <br />
              {/* third row */}
              {/* footer rased Remembe */}
              <div className="row pt2">
                <div className="col-lg-10 col-12">
                  <div className="row ">
                    <div className="col-lg-3 col-4">
                      <h3 className="bg-white tc mt2">
                        <NumberFormat
                          displayType="text"
                          thousandSeparator={true}
                          value={Number(RPD_paraRRR).toFixed(2)}
                        />
                      </h3>
                    </div>
                    <div className="col-lg-2 col-4">
                      <h3 className="text-warning tc  mt1">RRR پارە بە</h3>
                    </div>
                    <div className="col-lg-2 col-4"></div>
                    <div className="col-lg-3 col-4">
                      {/* <h3 className="bg-white tc mt2"><NumberFormat displayType='text' thousandSeparator={true} value={Number(RB_paraRRR).toFixed(2)} /></h3> */}
                    </div>
                    <div className="col-lg-2 col-4 mt1">
                      {/* <h3 className="text-warning tc ">RRR پارە بە </h3> */}
                    </div>
                  </div>
                </div>
              </div>
              <br />
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};

export default FooterOfParadan;
